import React, { FC } from "react";
import { Grid, InputLabel, Tooltip, FormHelperText } from "@mui/material";
import { TimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"; // Adapter for Day.js
import { FormFieldProps } from "../../../utils/formFields";
import useStyles from "../model/styles";
import dayjs from "dayjs";

const FormTimeField: FC<FormFieldProps> = (props) => {
  const classes = useStyles();

  const handleTimeChange = (time: any) => {
    const event = {
      target: {
        id: props.id,
        value: time ? time.format("HH:mm") : null, // Convert time to 'HH:mm' format
      },
    };
    props.onChange?.(event); // Call onChange if provided
  };

  const timePickerRender = () => (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <TimePicker
        value={props.value ? dayjs(props.value, "HH:mm") : null}
        onChange={handleTimeChange}
         ampm={false}              // ✅ IMPORTANT (forces 24-hour)
  format="HH:mm"            // ✅ display format
        slotProps={{
          textField: {
            style: { marginTop: props?.isNonMarginTop ? '0px' : '' },
            hiddenLabel: true,
            variant: "outlined",
            fullWidth: true,
           
            onBlur: (e: any) => {
              props?.onBlur && props?.onBlur({
                target: {
                  id: props.id
                }
              });
            },
            InputProps: {
              sx: {
                background: props?.disableBackground ? props?.disableBackground : '#fff',
                height: '36px',
                "&.Mui-disabled": {
                  backgroundColor: props?.disableBackground && "#eeecef",
                  color: "black",
                },
              },
            },
            placeholder: "hh:mm",
            name: props.id,
            margin: "normal",
            error: !!props.error,
          },
        }}
        minTime={props.minTime ? dayjs(props.minTime, "HH:mm") : undefined}
        maxTime={props.maxTime ? dayjs(props.maxTime, "HH:mm") : undefined}
      />
      {props.error && (
        <FormHelperText sx={{ color: "#d32f2f", marginLeft: "14px", marginTop: '-6px' }}>
          {props.helperText}
        </FormHelperText>
      )}
    </LocalizationProvider>
  );

  return (
    <>
      {props.label && !props.inSingleGridForm ? (
        <>
          <Grid 
            item 
            xs={12} 
            sm={props?.md ? (props?.firstColmd ? props?.firstColmd : 1.5) : 5} 
            className={classes.labelBox} 
            sx={{ marginTop: props?.isNonMarginTop ? '0px !important' : '' }}
          >
            <Tooltip title={props?.tooltipText || ''} arrow>
              <InputLabel 
                sx={{
                  color: "#333333",
                  fontWeight: 600,
                  fontSize: props.labelFontSize || "18px",
                }}
                shrink 
                htmlFor={props.id}
              >
                {props.label}
                {props.isRequired && (
                  <span style={{ color: 'red', fontWeight: 500 }}>*</span>
                )}
              </InputLabel>
            </Tooltip>
          </Grid>
          <Grid item xs={12} sm={props?.md ? props?.md : 7} style={{ padding: "0px" }}>
            {timePickerRender()}
          </Grid>
        </>
      ) : props.label && props.inSingleGridForm ? (
        <Grid
          item
          xs={12}
          sm={props?.md ? props?.md : 12}
          sx={{
            display: "block",
            alignItems: "center",
            gap: 2,
            ...props?.GridFieldStyle,
          }}
        >
          <Tooltip title={props?.tooltipText || ""} arrow>
            <InputLabel
              sx={{
                color: "#637381",
                fontWeight: 600,
                fontSize: props.labelFontSize || "16px",
                textAlign: "left",
              }}
              shrink
              htmlFor={props.id}
            >
              {props.label}
              {props.isRequired && (
                <span style={{ color: "red", fontWeight: 500 }}>*</span>
              )}
            </InputLabel>
          </Tooltip>
          {timePickerRender()}
        </Grid>
      ) : (
        timePickerRender()
      )}
    </>
  );
};

export default FormTimeField;
